import { render } from "./BranchSessionIndex.vue?vue&type=template&id=641f6b54"
import script from "./BranchSessionIndex.vue?vue&type=script&lang=js"
export * from "./BranchSessionIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__